// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/baby.js';

import { paths } from '../generated/baby';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('baby', Original, paths);
